<template>
  <v-app>
    <update-alert />
    <router-view />
  </v-app>
</template>

<script>
import UpdateAlert from "./templates/Components/UpdateAlert.vue";

export default {
  name: "App",
  components: { UpdateAlert },
};
</script>